import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AppPageComponent
} from 'common';
import { UserPasswordResetGuard } from './user-password-reset.guard';

const routes: Routes = [
  {
    path: 'password-reset',
    component: AppPageComponent,
    canActivate: [UserPasswordResetGuard],
    data: {
      appPage: {
          contentClass: 'simple',
          contentAlignment: 'center-start',
          contentWithoutPadding: true
      },
      appBar: {
        stickyDisabled: true
      }
  },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserPasswordResetRoutingModule { }